import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { LeiCategory, ORDERED_LANGUAGES } from '../../../../constants';
import { Checkbox, Datepicker, Fieldset, Input, List, Select } from '../../../form';

export type LEIType = {
  category: LeiCategory;
  lei: string;
  branch?: string;
  country?: string;
  name?: string;
};

export type FinalTermsDetailsFieldsType = {
  date: Date;
  language: string;
  leiIssuers: LEIType[];
  leiGuarantors: LEIType[];
  euGreenBonds: boolean;
  bondMarketedAsEnvSys: boolean;
  susLinkedBonds: boolean;
};

export type FinalTermsDetailsFieldsProps = {
  controlId: string;
};

export const FinalTermsDetailsFields: React.FC<React.PropsWithChildren<FinalTermsDetailsFieldsProps>> = ({ controlId }) => {
  return (
    <div className="final-terms-details-fields">
      <Row>
        <Col xs={12} lg={3}>
          <Datepicker label="Date of the Final Terms" controlId={`${controlId}.date`} required={true} />
        </Col>
        <Col xs={12} lg={3}>
          <Select
            options={ORDERED_LANGUAGES.map((language) => ({
              value: language.id,
              label: language.id,
              orderIndex: language.orderIndex,
            }))}
            label="Language of the document"
            controlId={`${controlId}.language`}
            required={true}
          />
        </Col>
        <Col xs={12} lg={6}>
          <label>
            <strong>REGULATION (EU) 2023/2631 (the EUGBR)</strong>
          </label>
          <Checkbox label="EuGB" help="Full compliance with Title II of the EUGBR" controlId={`${controlId}.euGreenBonds`} />
          <Checkbox
            label="Bonds marketed as environmentally sustainable"
            help="Pursuant to Article 21 of the EUGBR"
            controlId={`${controlId}.bondMarketedAsEnvSys`}
          />
          <Checkbox label="Sustainable-linked bonds" help="Pursuant to Article 21 of the EUGBR" controlId={`${controlId}.susLinkedBonds`} />
        </Col>
      </Row>
      <Row>
        <Col xs={12} lg={6}>
          <Fieldset className="gray">
            <List
              controlId={`${controlId}.leiIssuers`}
              model={{ lei: '', category: LeiCategory.ISSUER }}
              label="Issuer(s) of the Final Terms"
              headers={[{ label: 'LEI', required: true }]}
              disableRemovalOnFirstRow={true}
            >
              <Input controlId="lei" type="text" additionalAttributes={{ maxLength: 20 }} />
            </List>
          </Fieldset>
        </Col>
        <Col xs={12} lg={6}>
          <Fieldset className="gray">
            <List
              controlId={`${controlId}.leiGuarantors`}
              model={{ lei: '', category: LeiCategory.GUARANTOR }}
              label="Guarantor(s) of the Final Terms"
              headers={[{ label: 'LEI', required: true }]}
            >
              <Input controlId="lei" type="text" additionalAttributes={{ maxLength: 20 }} />
            </List>
          </Fieldset>
        </Col>
      </Row>
    </div>
  );
};
